import React from 'react'
import { loader } from '@giphy/js-brand'

const BrandLoader = ({ className }: { className?: string }) => (
    <div className={`${loader} ${className}`}>
        <div />
        <div />
        <div />
        <div />
        <div />
    </div>
)

export default BrandLoader
